// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1L9V9","inputDescription":"styles_inputDescription__3OsAl"};